<template>
    
        <div class="register" name="register">
            <topNav :title="title"></topNav>
            <van-cell-group class="form_box">
                <div class="ipt ipt_phoneNumer">
                    <i></i><van-field class="right_input" v-model="phonenumber" maxlength=11 clearable placeholder="请输入手机号" />
                </div>
                <div class="ipt ipt_authCode">
                    <i></i><van-field class="right_input" v-model="authCode" maxlength=6 clearable placeholder="请输入验证码" >
                    <van-button slot="button" size="small" type="primary" :disabled="!countDown.canGet" @click="getAuthCode()">
                      <span v-show="!countDown.canGet">{{"重新发送"+countDown.waitTime+"s"}}</span>
                      <span v-show="countDown.canGet">获取验证码</span>
                    </van-button>
                    </van-field>
                </div>
                <div class="ipt ipt_password">
                    <i></i><van-field v-model="password" type="password" clearable placeholder="请输入6-18位密码" />
                </div>
            </van-cell-group>
            
            <div class="btns">
                <van-button type="info" @click="userRegister()">注册</van-button>
            </div>
        </div>
    </template>
    
    <script>
      import Vue from 'vue'
      import topNav from "../topnav/topnav";
      import { Field,Cell,CellGroup,Button,Toast } from 'vant';
      import {DETAIL as API} from "@/assets/api";
    
      export default {
        name: 'register',
        components:{
          topNav,
          Field,
          [Cell.name]:Cell,
          [CellGroup.name]:CellGroup,
          Button,
          Toast
        },
        data() {
          return {
            title:"注册",
            phonenumber: '',
            password: '',
            authCode: '',
            countDown: { //验证码倒计时
              canGet: true,
              Timer: null,
              waitTime: 60
            },
          }
        },
        created() {
          this.phonenumber = this.$route.params.phonenumber;
        },
        methods:{
            getAuthCode(){
              if(!this.commonUtil.validPhone(this.phonenumber)) return;
                  
              let originalId = this.$store.state.originalId;

              let req = {
                originalId: originalId,
                phonenumber: this.phonenumber
              }
              
              this.commonUtil.timeCountDown(this.countDown);
          
              this.$http({
                  method: 'post',
                  url: API.GET_AUTH_CODE,
                  data: this.qs.stringify(req),
                  success: function(data){
                    if(data.code != 0) Toast(data.msg)
                  }.bind(this),
                  error: function(error){
                      console.log(error)
                  }
              })
            },
          userRegister(){
            let browserType = this.$store.state.browserType;
            if(browserType !== 'wx' && browserType !== 'al') {Toast('请用微信或者支付宝打开!');return}
            if(!this.commonUtil.validPhone(this.phonenumber)) return; //验证手机号
            if(!this.authCode){Toast('请输入验证码');return} // 验证是否填写了验证码
            if(!this.commonUtil.validPassword(this.password)) return; // 验证密码长度

            let originalId = this.$store.state.originalId;

            let req = {
              originalId: originalId,
              phonenumber: this.phonenumber,
              password: this.password,
              verifycode: this.authCode,
              browserType: browserType
            }

            this.$http({
                method: 'post',
                url: API.REGISTER,
                data: this.qs.stringify(req),
                success: function(data){
                  if(data.code == 0){
                    this.$toast({duration:1000,message:'注册成功!'});
                    setTimeout(()=>{
                      this.$router.push({name:'login',params:req});
                    },1000)
                  }else{
                    Toast(data.msg)
                  }
                }.bind(this),
                error: function(error){
                    Toast('连接超时,请稍后重试!')
                }
            })
            
          }
        }
      }
    </script>
    <style lang="less" scoped>
      .form_box{
        margin-bottom: 30px;
        .ipt{
          box-sizing: border-box;
          height: 44px;
          padding-left: 30px;
          position: relative;
          background-color: #fff;
          overflow: hidden;
          border-bottom: 1px solid #eee;
          &:last-of-type{
            border-bottom: none;
          }
          i{
            display: block;
            min-width: 1em;
            height: 24px;
            margin-right: 5px;
            position: absolute;
            left: 10px;
            top: 10px;
          }
          .van-cell{
            padding: 0 15px;
            line-height: 44px;
          }
          .btn_getauthcode{
              width: 100px;
              height: 100%;
              position: absolute;
              right: 0;
              top: 0;
              border: none;
              outline: none;
              padding: 0;
              text-align: center;
              line-height: 44px;
          }
          &.ipt_phoneNumer{
            i{
              background: url('../../../static/images/icon_phone.png') center no-repeat;
              background-size: 100%;
            }
          }
          &.ipt_authCode{
            i{
                width: 22px;
                left: 7px;
              background: url('../../../static/images/icon_authCode.png') center no-repeat;
              background-size: contain;
            }
          }
          &.ipt_password{
            i{
              background: url('../../../static/images/icon_lock.png') center no-repeat;
              background-size: 100%;
            }
          }
        }
      }
      .btns{
        padding: 0 15px;
        .van-button{
          border-radius: 3px;
          outline: none;
          border: none;
          width: 100%;
          // height: 100%;
          background-color: #4687f8;
          color: #fff;
        }
        .other{
          line-height: 24px;
          font-size: 14px;
          color: #333;
          &:after{
            content: ' ';
            display: table;
            clear: both;
          }
        }
        .register{
          float: left;
        }
        .forgetPassword{
          float: right;
        }
      }
    </style>
    
    


// WEBPACK FOOTER //
// src/components/my/register.vue